<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{
        $t('message.closeConfirmation.header')
      }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-icon color="error" class="warningIcon" x-large>
          mdi-alert-octagon
        </v-icon>
      </v-row>
      <v-card-title class="justify-center">
        {{ $t('message.closeConfirmation.text1') }}
      </v-card-title>
      <v-row>
        <v-btn id="leaveRoomButton" color="success" @click="closeDialog()">
          {{ $t('message.closeConfirmation.continue') }}
          <v-icon right>mdi-arrow-right-bold</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-card-text class="text-center">
          {{ $t('message.closeConfirmation.text2') }}
        </v-card-text>
      </v-row>
      <v-row>
        <v-btn id="leaveRoomButton" color="error" @click="leaveRoom()">
          {{ $t('message.closeConfirmation.close') }}
          <v-icon right>mdi-phone-hangup</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    closeDialog: { type: Function },
    leaveRoom: { type: Function }
  }
};
</script>

<style>
#leaveRoomButton {
  margin: auto;
}

.warningIcon {
  margin: auto;
  margin-top: 5%;
}

.warningText {
  text-align: center;
}
</style>
